"use client";

import { c as _c } from "react/compiler-runtime";
import { FlexCenter, ToggleButtonGroup, ToggleButtonGroupItem, Tooltip } from "@opensea/ui-kit";
import { useTranslations } from "use-intl";
import { useSwapContext } from "../provider/SwapContext";
import { SwapConfiguration } from "./SwapConfiguration";
export const SwapHeader = () => {
  const $ = _c(20);
  const t = useTranslations("wallet.SwapHeader");
  const {
    variant
  } = useSwapContext();
  const t0 = variant === "frosted" ? "secondary-frosted" : "secondary";
  let t1;
  if ($[0] !== t) {
    t1 = t("swapTab");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <ToggleButtonGroupItem value="swap">{t1}</ToggleButtonGroupItem>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t) {
    t3 = t("comingSoon");
    $[4] = t;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t) {
    t4 = t("buyTab");
    $[6] = t;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t4) {
    t5 = <span><ToggleButtonGroupItem disabled={true} value="buy">{t4}</ToggleButtonGroupItem></span>;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t3 || $[11] !== t5) {
    t6 = <Tooltip content={t3}>{t5}</Tooltip>;
    $[10] = t3;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t0 || $[14] !== t2 || $[15] !== t6) {
    t7 = <ToggleButtonGroup size="md" value="swap" variant={t0}>{t2}{t6}</ToggleButtonGroup>;
    $[13] = t0;
    $[14] = t2;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <SwapConfiguration />;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t7) {
    t9 = <FlexCenter className="w-full justify-between p-4">{t7}{t8}</FlexCenter>;
    $[18] = t7;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  return t9;
};